/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiAdminDtoBatchJobsSummaryDto } from './WebApiAdminDtoBatchJobsSummaryDto';
import {
    WebApiAdminDtoBatchJobsSummaryDtoFromJSON,
    WebApiAdminDtoBatchJobsSummaryDtoFromJSONTyped,
    WebApiAdminDtoBatchJobsSummaryDtoToJSON,
} from './WebApiAdminDtoBatchJobsSummaryDto';
import type { WebApiAdminDtoErrorsSummaryDto } from './WebApiAdminDtoErrorsSummaryDto';
import {
    WebApiAdminDtoErrorsSummaryDtoFromJSON,
    WebApiAdminDtoErrorsSummaryDtoFromJSONTyped,
    WebApiAdminDtoErrorsSummaryDtoToJSON,
} from './WebApiAdminDtoErrorsSummaryDto';
import type { WebApiAdminDtoIntegrationStatusDto } from './WebApiAdminDtoIntegrationStatusDto';
import {
    WebApiAdminDtoIntegrationStatusDtoFromJSON,
    WebApiAdminDtoIntegrationStatusDtoFromJSONTyped,
    WebApiAdminDtoIntegrationStatusDtoToJSON,
} from './WebApiAdminDtoIntegrationStatusDto';
import type { WebApiAdminDtoRecentActivityDto } from './WebApiAdminDtoRecentActivityDto';
import {
    WebApiAdminDtoRecentActivityDtoFromJSON,
    WebApiAdminDtoRecentActivityDtoFromJSONTyped,
    WebApiAdminDtoRecentActivityDtoToJSON,
} from './WebApiAdminDtoRecentActivityDto';
import type { WebApiAdminDtoSyncActivityDto } from './WebApiAdminDtoSyncActivityDto';
import {
    WebApiAdminDtoSyncActivityDtoFromJSON,
    WebApiAdminDtoSyncActivityDtoFromJSONTyped,
    WebApiAdminDtoSyncActivityDtoToJSON,
} from './WebApiAdminDtoSyncActivityDto';
import type { WebApiAdminDtoSystemOverviewDto } from './WebApiAdminDtoSystemOverviewDto';
import {
    WebApiAdminDtoSystemOverviewDtoFromJSON,
    WebApiAdminDtoSystemOverviewDtoFromJSONTyped,
    WebApiAdminDtoSystemOverviewDtoToJSON,
} from './WebApiAdminDtoSystemOverviewDto';

/**
 * Admin dashboard data for system monitoring
 * @export
 * @interface WebApiAdminDtoAdminDashboardDto
 */
export interface WebApiAdminDtoAdminDashboardDto {
    /**
     * 
     * @type {WebApiAdminDtoSystemOverviewDto}
     * @memberof WebApiAdminDtoAdminDashboardDto
     */
    systemOverview?: WebApiAdminDtoSystemOverviewDto;
    /**
     * Integration health status for all companies
     * @type {Array<WebApiAdminDtoIntegrationStatusDto>}
     * @memberof WebApiAdminDtoAdminDashboardDto
     */
    integrationStatuses?: Array<WebApiAdminDtoIntegrationStatusDto> | null;
    /**
     * 
     * @type {WebApiAdminDtoRecentActivityDto}
     * @memberof WebApiAdminDtoAdminDashboardDto
     */
    recentActivity?: WebApiAdminDtoRecentActivityDto;
    /**
     * 
     * @type {WebApiAdminDtoBatchJobsSummaryDto}
     * @memberof WebApiAdminDtoAdminDashboardDto
     */
    batchJobsSummary?: WebApiAdminDtoBatchJobsSummaryDto;
    /**
     * 
     * @type {WebApiAdminDtoErrorsSummaryDto}
     * @memberof WebApiAdminDtoAdminDashboardDto
     */
    errorsSummary?: WebApiAdminDtoErrorsSummaryDto;
    /**
     * 
     * @type {WebApiAdminDtoSyncActivityDto}
     * @memberof WebApiAdminDtoAdminDashboardDto
     */
    syncActivity?: WebApiAdminDtoSyncActivityDto;
}

/**
 * Check if a given object implements the WebApiAdminDtoAdminDashboardDto interface.
 */
export function instanceOfWebApiAdminDtoAdminDashboardDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoAdminDashboardDtoFromJSON(json: any): WebApiAdminDtoAdminDashboardDto {
    return WebApiAdminDtoAdminDashboardDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoAdminDashboardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoAdminDashboardDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'systemOverview': !exists(json, 'systemOverview') ? undefined : WebApiAdminDtoSystemOverviewDtoFromJSON(json['systemOverview']),
        'integrationStatuses': !exists(json, 'integrationStatuses') ? undefined : (json['integrationStatuses'] === null ? null : (json['integrationStatuses'] as Array<any>).map(WebApiAdminDtoIntegrationStatusDtoFromJSON)),
        'recentActivity': !exists(json, 'recentActivity') ? undefined : WebApiAdminDtoRecentActivityDtoFromJSON(json['recentActivity']),
        'batchJobsSummary': !exists(json, 'batchJobsSummary') ? undefined : WebApiAdminDtoBatchJobsSummaryDtoFromJSON(json['batchJobsSummary']),
        'errorsSummary': !exists(json, 'errorsSummary') ? undefined : WebApiAdminDtoErrorsSummaryDtoFromJSON(json['errorsSummary']),
        'syncActivity': !exists(json, 'syncActivity') ? undefined : WebApiAdminDtoSyncActivityDtoFromJSON(json['syncActivity']),
    };
}

export function WebApiAdminDtoAdminDashboardDtoToJSON(value?: WebApiAdminDtoAdminDashboardDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'systemOverview': WebApiAdminDtoSystemOverviewDtoToJSON(value.systemOverview),
        'integrationStatuses': value.integrationStatuses === undefined ? undefined : (value.integrationStatuses === null ? null : (value.integrationStatuses as Array<any>).map(WebApiAdminDtoIntegrationStatusDtoToJSON)),
        'recentActivity': WebApiAdminDtoRecentActivityDtoToJSON(value.recentActivity),
        'batchJobsSummary': WebApiAdminDtoBatchJobsSummaryDtoToJSON(value.batchJobsSummary),
        'errorsSummary': WebApiAdminDtoErrorsSummaryDtoToJSON(value.errorsSummary),
        'syncActivity': WebApiAdminDtoSyncActivityDtoToJSON(value.syncActivity),
    };
}

